var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { t } from 'helpers/i18n';
import History from 'helpers/History';
import { sections } from 'scenes/Main';
import { Button, Icon } from 'elements';
let NavBar = class NavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedSection: undefined,
            activePath: undefined
        };
        this.handleSection = (selectedSection) => () => {
            this.setState({ selectedSection });
            if (selectedSection)
                this.handleLink(selectedSection.links[0].path)();
        };
        this.handleLink = activePath => () => {
            this.setState({ activePath });
            History.push(activePath);
        };
        const currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
        const selectedSection = currentPath
            ? sections(props.store.users.user).find(section => section.links.find(link => link.path.indexOf(currentPath) > -1)
                ? true
                : false)
            : undefined;
        this.state.selectedSection = selectedSection;
        this.state.activePath = currentPath;
    }
    render() {
        const { selectedSection } = this.state;
        return (React.createElement(Wrapper, null,
            selectedSection ? (React.createElement(Button, { onClick: this.handleSection() },
                React.createElement(Icon, { name: "back" }))) : null,
            !selectedSection
                ? sections(this.props.store.users.user).map(section => (React.createElement(StyledButton, { key: section.name, onClick: this.handleSection(section) }, t(section.name))))
                : selectedSection.links.map(link => (React.createElement(StyledButton, { key: link.name, primary: isActive(link.path), onClick: this.handleLink(link.path) }, t(link.name))))));
    }
};
NavBar = __decorate([
    inject('store')
], NavBar);
export default NavBar;
const Wrapper = cxs('div')({
    display: 'flex',
    height: Theme.size.bar,
    borderTop: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
    backgroundColor: Theme.color.background
});
const StyledButton = cxs(Button)({
    flex: 1
});
const pathRegex = /\/(\w*)/;
// const pathRegex = /\/.*?\/(\w*)/
const isActive = (_path) => {
    const currentPath = (pathRegex.exec(History.location.pathname) || [])[1];
    const path = (pathRegex.exec(_path) || [])[1];
    return currentPath === path;
};



//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar.tsx
// module id = 539
// module chunks = 0